export default __webpack_public_path__ + "static/media/i_bus-jeonse_gy.0dcc8df6.svg";